let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hQYcg")).then(() => parcelRequire('8JOz7'));